<template>
  <v-dialog v-model="show" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
              <v-select
                v-model="object.tipo_cliente"
                :items="tipoCliente"
                label="Tipo de cliente"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="object.nombre"
                label="Nombre"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-select
                v-model="object.tipo_documento"
                :items="documentos"
                label="Tipo Documento"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="object.num_documento"
                label="Número Documento"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-select
                v-model="object.zona"
                :items="zonas"
                label="Zona"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="object.direccion"
                label="Dirección"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="object.telefono"
                label="Teléfono"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field v-model="object.email" label="Email"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
        <v-btn color="blue darken-1" text @click="guardar">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      tipoCliente: ["Minorista", "Mayorista"],
      documentos: ["DNI", "RUC", "PASAPORTE", "CEDULA"],
      zonas: [
        { text: "Zona 1", value: 1 },
        { text: "Zona 2", value: 2 },
        { text: "Zona 3", value: 3 },
        { text: "Zona 4", value: 4 },
      ],
    };
  },
  props: {
    object: Object,
    show: Boolean,
    update: Boolean,
    detalle: Boolean,
  },
  computed: {
    formTitle() {
      let me = this;
      let titulo = "";
      if (me.update) {
        titulo = "Edución de registro";
      } else if (me.detalle) {
        titulo = "Detalle";
      } else {
        titulo = "Nuevo registro";
      }
      // this.update ? "Edución de registro" : "Nuevo registro";
      return titulo;
    },
  },
  methods: {
    guardar() {
      this.$emit("save", this.object);
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style></style>
